import React, { useCallback, useContext, useEffect, useState } from 'react'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import axios from 'axios';
import { LoadingContext } from '../../context/LoadingContext';
import ReactLoader from '../../components/ReactLoader';
import { CartContext } from '../../context/CartContext';
const config = require('../../config.json')


export default function Product({ ipAddress, loginData }) {
    const [info, setInfo] = useState({});
    const { addToCart } = useContext(CartContext)
    const [loading, setLoading] = useContext(LoadingContext)
    const [isset, setIsset] = useState(false);
    const handleInfo = useCallback(() => {
        setLoading(true)
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}products`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        // console.log(axiosConfig)
        axios.request(axiosConfig)
            .then((response) => {
                console.log(response.data)
                setInfo(response.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [ipAddress, loginData.auth, loginData.token, loginData.ulid, setLoading])

    useEffect(() => {
        handleInfo()
    }, [handleInfo])

    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    {loading ? <><ReactLoader /></> :
                        <div className="content-wrapper mb-4">
                            <div className="container-xxl flex-grow-1 container-p-y pt-2">
                                <div>
                                    <div className='row'>
                                        <div className="col-md-12  mb-2">
                                            <div className="card">
                                                <div className="card-header align-items-center ">
                                                    <div className="card-title mb-0">
                                                        <h6 className="m-0 text-center text-black ">Products by AD Herbal</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        {
                                            info?.info?.map((list, index) => {
                                                return (
                                                    <div className="col-lg-4 col-md-6 col-sm-6 col-6 mb-2" key={index + 1001}>
                                                        <div className="card text-center h-100">
                                                            <img className="card-img-top" src={list.link} alt={list.product_name + ' Image'} height={'100px'} width={'100%'} />
                                                            <div className="card-body m-0 p-2">
                                                                <div className='mb-1'>
                                                                    <p className="card-title m-1">{list.product_name}</p>
                                                                    <p className="card-text text-sm m-1">
                                                                        {list.product_info}
                                                                    </p>
                                                                    <p className="card-text text-sm mb-0">MRP : <strike><i className='fa fa-inr'></i>{list?.product_mrp}</strike> </p>
                                                                    <p className="card-text text-sm mb-0">DP : <b><i className='fa fa-inr'></i>{list?.product_dp}</b></p>
                                                                    <p className="card-text text-sm mb-0"> (<b>{list?.product_bv}</b>(BV))</p>
                                                                </div>
                                                                <button className="btn btn-info btn-sm mb-1" onClick={() => addToCart(list)}>Add To Cart</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>}
                </div>
            </div>

        </>
    );
}